import { createError } from './create-error';

export const UnhandledError = createError(
  'UnhandledError',
  (error: Error) => `Unhandled error: ${error.message}`,
  {
    ERROR: 'An unhandled error was caught in a callback.',
    ASYNC_ERROR: 'An unhandled promise rejection was caught in a callback.',
  } as const
);
